module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAELSURBVHgB7ZddCoMwDIDjHkQfvUGvspN7FHsDn1TwpWtGFSmTxSatbOSD4A8mfljbUABFURTl95nnecBYlsUAE6yx1aM8/6A85JzDMD56jiTmYo1Qi5RDElzX9ekPliN5lMNaoaYc4ziaaZoGH+7qcG/DirlYA2tBDlIki8mlSBaXuyJ5mxxFUlKuAgb44rque39qqqqyPt4zM56tXddZSIQl+EkyCBoJOTGOwy39z5EW6m80TQP+6+3XeI73JGAPcdwhwu39n2zb1gIDluBZ+4onDlcyWe5sKeG0xexyt0teWYSLS6Z0iGKSnPaVXVKit2aVlGr8sSQlh7wnAYHeirmH7QMoiqIof8ALQHZFrXgNSasAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/x.png
// module id = mWOz
// module chunks = 1